import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../shared/product.service';
import { NgForm } from '@angular/forms';
import { CategoryService } from '../../shared/category.service';
import { Category } from '../../shared/category.model';
import { AngularFirestore } from '@angular/fire/firestore';
import { Subcategory } from '../../shared/subcategory.model';
import { SubcategoryService } from '../../shared/subcategory.service';
import { ToastrService } from 'ngx-toastr';
import { StoresService } from '../../shared/stores.service';
import { Stores } from '../../shared/stores.model';
import { Observable } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {

  categorys: Category[];
  subCategorys: Subcategory[];
  stores: Stores[];
  //title = "jenjohns";

  uploadPercent: Observable<number>;
  downloadURL: Observable<string>;
  selectedFIle = null;


  constructor(private service: ProductService,
    private categoryService: CategoryService,
    private subcategoryService: SubcategoryService,
    private storeService: StoresService,
    private storage: AngularFireStorage,
    private firestore: AngularFirestore,
    private toastr: ToastrService) { }

  ngOnInit() {
    this.resetForm();

    this.categoryService.getCategory().subscribe(actionArray => {
      this.categorys = actionArray.map(item => {
        const data = item.payload.doc.data() as Category;
        const id = item.payload.doc.id;
        return { id, ...data };
      })
    });

    this.subcategoryService.getSubcategory().subscribe(actionArray => {
      this.subCategorys = actionArray.map(item => {
        const data = item.payload.doc.data() as Subcategory;
        const id = item.payload.doc.id;
        return { id, ...data };
      })
    });

    this.storeService.getStores().subscribe(actionArray => {
      this.stores = actionArray.map(item => {
        const data = item.payload.doc.data() as Stores;
        const id = item.payload.doc.id;
        return { id, ...data };
      })
    });
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.resetForm();
    this.service.productData = {
      id: null,
      name: '',
      price: '',
      category: '',
      subCategory: '',
      store: '',
      image: '',
      barCode: '',
      quantity: null,
      order: null,
      status: '',
      desc: ''
    }
    this.selectedFIle = null;

  }
  onSubmit(form: NgForm) {
    let data = Object.assign({}, form.value)
    data.quantity = Number(data.quantity)
    data.order = Number(data.order)
    delete data.id;
    delete data.image;
    if (form.value.id == null) {
      if (form.value.image != null) {
        let file = null;
        file = this.selectedFIle;
        const filePath = 'products/' + data.name;
        const fileRef = this.storage.ref(filePath);
        const task = this.storage.upload(filePath, file);

        //observe percentage changes
        this.uploadPercent = task.percentageChanges();
        //get notified when the download URL is available
        task.snapshotChanges().pipe(
          finalize(() => {

            fileRef.getDownloadURL().subscribe(downloadURL => {
              console.log(downloadURL);
              data.image = downloadURL;
              this.firestore.collection('products').add(data);
            });
          })
        )
          .subscribe()
      } else {

        data.image = "https://firebasestorage.googleapis.com/v0/b/grocery-c405e.appspot.com/o/NoCImage.jpg?alt=media&token=7250de89-9786-481b-b13b-15fb0d0cf55e";
        this.firestore.collection('products').add(data);

      }

    }
    else {

      let documentId = form.value.id
      console.log(documentId)
      if (form.value.image != null && this.selectedFIle != null) {
        let file = null;
        file = this.selectedFIle;
        const filePath = 'products/' + data.name;
        const fileRef = this.storage.ref(filePath);
        const task = this.storage.upload(filePath, file);

        //observe percentage changes
        this.uploadPercent = task.percentageChanges();
        //get notified when the download URL is available
        task.snapshotChanges().pipe(
          finalize(() => {

            fileRef.getDownloadURL().subscribe(downloadURL => {
              console.log(downloadURL);
              data.image = downloadURL;
              this.firestore.doc('products/' + documentId).update(data);
            });
          })
        )
          .subscribe()
      } else {
        delete data.image;
        this.firestore.doc('products/' + documentId).update(data);
      }
    }
    this.resetForm(form);
    this.toastr.success('Submitted Successfully', 'Products')
  }

  uploadFile(event) {

    this.selectedFIle = event.target.files[0];
  }

}
